var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 182,
    viewBox: "0 0 182 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 91,
    r: 91,
    fill: "#8B929D",
    fillOpacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.7359 94.1069C92.7054 94.1069 103.102 83.5761 103.102 70.4389C103.102 57.3016 92.7054 46.7708 79.7359 46.7708C66.7665 46.7708 56.3702 57.3016 56.3702 70.4389C56.3702 83.5761 66.7665 94.1069 79.7359 94.1069ZM79.7295 105.697C60.6806 105.697 44.417 108.742 44.417 120.91C44.417 133.074 60.5817 136.229 79.7295 136.229C98.7736 136.229 115.042 133.184 115.042 121.015C115.042 108.847 98.8773 105.697 79.7295 105.697ZM128.686 80.1428H134.351C136.683 80.1428 138.584 82.0706 138.584 84.435C138.584 86.7994 136.683 88.7272 134.351 88.7272H128.686V94.2703C128.686 96.6347 126.79 98.5625 124.454 98.5625C122.122 98.5625 120.221 96.6347 120.221 94.2703V88.7272H114.566C112.23 88.7272 110.334 86.7994 110.334 84.435C110.334 82.0706 112.23 80.1428 114.566 80.1428H120.221V74.6047C120.221 72.2403 122.122 70.3125 124.454 70.3125C126.79 70.3125 128.686 72.2403 128.686 74.6047V80.1428Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add_user.1b36eb2323f99ed61088ec0fdc1d8160.svg";
export { ForwardRef as ReactComponent };